/**
 * ENVIRONMENT: PRODUCTION
 * MODULE: Central Axios API Client & Concurrent Session Guard
 * PATH: src/utils/api.js
 */

import axios from 'axios';
import { Modal } from 'antd';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://billpay.mtmpay.in/Admin/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request Interceptor: Attach Active Bearer Token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isTerminatedModalShowing = false;

// Response Interceptor: Handle Invalidation & Concurrent Logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response ? error.response.status : null;
    const errorMsg = error.response?.data?.message || '';

    // If 401 Unauthorized (Token Revoked due to new login elsewhere or expired)
    if (status === 401) {
      const isLoginPath = window.location.pathname.includes('/login');

      if (!isLoginPath && !isTerminatedModalShowing) {
        isTerminatedModalShowing = true;

        // Clear local storage & cookies
        localStorage.removeItem('token');
        sessionStorage.clear();

        const isConcurrent =
          errorMsg.toLowerCase().includes('another device') ||
          errorMsg.toLowerCase().includes('session') ||
          error.response?.data?.code === 'CONCURRENT_LOGIN';

        Modal.warning({
          title: 'Session Terminated',
          content: isConcurrent
            ? 'A new administrator login was initialized from another browser or device. For security, this session has been terminated.'
            : 'Your administrative session has expired. Please sign in again.',
          okText: 'Return to Login',
          onOk: () => {
            isTerminatedModalShowing = false;
            window.location.href = '/login';
          },
        });
      }
    }

    return Promise.reject(error);
  }
);

export default api;